<template>
  <PageWrapper>
    <template v-slot:content>
      <!--      主列表型号搜索-->
        <el-select
          ref="selectRef"
          @change="handleChange"
          class="model-select"
          v-model="keyword"
          filterable
          remote
          popper-append-to-body
          reserve-keyword
          :automatic-dropdown="true"
          :default-first-option="true"
          placeholder="请输入型号搜索"
          :remote-method="remoteMethod"
          :loading="loading">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
<!--      <el-button type="primary" @click="handleSearch(keyword)">搜索</el-button>-->
<!--      <CustomSelect-->
<!--        :options="options"-->
<!--        placeholder="请输入型号搜索"-->
<!--        :remoteMethod="remoteMethod"-->
<!--      />-->
      <div>
        <el-button type="primary" size="small" class="el-icon-plus custom-btn" @click="handleAdd">新增型号</el-button>
      </div>

      <el-card class="model-card">
        <!--        库存列表-->
        <div slot="header" class="clearfix">
          <span>库存</span>
        </div>
        <el-table border fit highlight-current-row class="model-table" :data="inventory">
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="商品名称" prop="title"></el-table-column>
          <el-table-column label="型号" prop="xhname" width="150"></el-table-column>
          <el-table-column label="品牌" prop="source"></el-table-column>
          <el-table-column label="含/未税" prop="spzt">
            <template #default="scope">
              {{ scope.row.spzt === '0' ? '未税' : '含税' }}
            </template>
          </el-table-column>
          <el-table-column label="库存数量" prop="number"></el-table-column>
          <el-table-column label="未税价格" prop="wshui"></el-table-column>
          <el-table-column label="含税价格" prop="hshui"></el-table-column>
          <el-table-column label="零售价" prop="price"></el-table-column>
          <el-table-column label="自定义价格" prop="zdyprice" width="100"></el-table-column>
          <el-table-column label="产地" prop="address"></el-table-column>
          <el-table-column label="包装" prop="baozhuang"></el-table-column>
          <el-table-column label="库房货位" prop="kufang"></el-table-column>
          <el-table-column label="进货日期" prop="settime" width="120"></el-table-column>
          <el-table-column label="供应商" prop="gongyingshang" width="220"></el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template #default="{row,$index}">
              <el-button type="primary" size="mini" :disabled="row.state === 'T' || disabledIndexes.includes(row.id)"
                         @click="addToDrawer(row,1,$index)">添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!--      数据列表-->
      <el-card class="model-card">
        <div slot="header" class="clearfix">
          <span>数据列表</span>
        </div>
        <div>
          <p>品牌：</p>
          <el-tag type="info" @click="getAllSource" style="margin-right: 3px;cursor: pointer"
                  :effect="selectedSourceTag == 1?'dark':'light'">不限
          </el-tag>
          <el-tag v-for="item in sourceData" style="margin:0 3px;cursor: pointer"
                  :effect="selectedSourceTag === item ? 'dark' : 'light'" @click="handleSource(item)">{{ item }}
          </el-tag>
        </div>
        <div>
          <p>价格来源：</p>
          <el-tag type="info" @click="getAllAddress" style="margin-right: 3px;cursor: pointer"
                  :effect="selectedAddressTag == 2?'dark':'light'">不限
          </el-tag>
          <el-tag v-for="item in addressData" type="warning" style="margin:0 3px;cursor: pointer"
                  :effect="selectedAddressTag === item ? 'dark' : 'light'" @click="handleAddress(item)">{{ item }}
          </el-tag>
        </div>
        <el-table border fit highlight-current-row class="model-table" :data="data">
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="型号" prop="xhname"></el-table-column>
          <el-table-column label="品牌" prop="source"></el-table-column>
          <el-table-column label="含/未税" prop="shui">
            <template #default="scope">
              {{ scope.row.shui === '0' ? '未税' : '含税' }}
            </template>
          </el-table-column>
          <el-table-column label="价格" prop="price"></el-table-column>
          <el-table-column label="型号" prop="renshu1">
            <template #header>
              <el-select v-model="renshu1" @change="updatePrices">
                <el-option v-for="item in percentOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
            <template #default="{ row }">
              {{ calcPrice(row.price, renshu1) }}
            </template>
          </el-table-column>
          <el-table-column label="型号" prop="renshu2">
            <template #header>
              <el-select v-model="renshu2" @change="updatePrices">
                <el-option v-for="item in percentOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
            <template #default="{ row }">
              {{ calcPrice(row.price, renshu2) }}
            </template>
          </el-table-column>
          <el-table-column label="型号" prop="renshu3">
            <template #header>
              <el-select v-model="renshu3" @change="updatePrices">
                <el-option v-for="item in percentOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
            <template #default="{ row }">
              {{ calcPrice(row.price, renshu3) }}
            </template>
          </el-table-column>
          <el-table-column label="型号" prop="renshu4">
            <template #header>
              <el-select v-model="renshu4" @change="updatePrices">
                <el-option v-for="item in percentOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </template>
            <template #default="{ row }">
              {{ calcPrice(row.price, renshu4) }}
            </template>
          </el-table-column>
          <el-table-column label="价格来源" prop="address"></el-table-column>
          <el-table-column label="创建时间" prop="ArticleTime"></el-table-column>
          <el-table-column label="操作" width="90" fixed="right">
            <template #default="{row,$index}">
              <el-button type="primary" size="mini" :disabled="row.state === 'T' || disabledIndexes.includes(row.id)"
                         @click="addToDrawer(row,2,$index)">添加
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <!--      已添加数据弹窗-->
      <el-drawer
        title="报价型号"
        :visible.sync="drawerVisible"
        :size="getIsMobile?'100%':'30%'">
        <el-table :data="addedData" border class="drawer-table">
          <el-table-column prop="xhname" label="型号" />
          <el-table-column prop="source" label="品牌" />
          <el-table-column label="操作">
            <template #default="{ row, $index }">
              <el-button
                type="danger"
                size="mini"
                @click="removeFromDrawer(row,$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="dialog-footer">
          <el-button @click="handleQuotation(addedData)" style="margin-right: 5px" type="primary">生成报价单</el-button>
          <el-button @click="handleClear" style="margin-right: 5px" type="danger">清空</el-button>
        </div>
        <!--        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"-->
        <!--                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"-->
        <!--                       :page-size="selectPage.pageSize"-->
        <!--                       background-->
        <!--                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"-->
        <!--                       style="margin-top: 14px;margin-bottom:14px"-->
        <!--        >-->
        <!--        </el-pagination>-->
      </el-drawer>
      <!--      型号列表弹窗-->
      <AddPage :dialog="dialog" @submit="handleAddSubmit" @close="handleAddClose" ref="addPageRef"/>
      <!--      已添加数据-生成报价单弹窗-->
      <CreateQuotation :dialog="quotationDialog" :data="quotationData" @close="quotationClose" />
      <el-button type="primary" plain class="add-btn" @click="handleAddXname">已添加（{{ addedData.length || addedNum }}）
      </el-button>
    </template>
  </PageWrapper>
</template>
<script>
import { ref, defineComponent, watch, getCurrentInstance,onMounted,onBeforeUnmount,nextTick } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import request from '@/utils/request'
import AddPage from './addPage'
import { Message } from 'element-ui'
import CreateQuotation from './createQuotation'
import useRootSetting from '@/hooks/useRootSetting'
import CustomSelect from '@/components/CustomSelect/index.vue'
export default defineComponent({
  components: { PageWrapper, AddPage, CreateQuotation,CustomSelect },
  setup() {
    // const selectPage = reactive({
    //   pageNum: 1,
    //   pageSize: 20
    // })
    const { getIsMobile } = useRootSetting()
    const addPageRef = ref(null)//调用里面的reset方法
    const drawerVisible = ref(false) //控制已添加数据弹窗
    const addedData = ref([])//已添加的数据
    const keyword = ref('')//搜索型号关键字
    const loading = ref(false)//搜索loading
    const options = ref([])//模糊搜索下拉列表
    const dialog = ref(false)//新增型号列表的弹窗
    const quotationDialog = ref(false)//已添加里生成报价单的弹窗
    const inventory = ref([])//库存列表数据
    const data = ref([])//数据列表
    const sourceData = ref([])//品牌搜索数据
    const addressData = ref([])//价格来源搜索数据
    const ArticleSource = ref('')//选中的品牌搜索
    const address = ref('')//选中的价格来源搜索
    const xhName = ref('')//模糊下拉选中的型号搜索
    const selectedSourceTag = ref(null)//区分搜索字段是否选中
    const selectedAddressTag = ref(null)
    const quotationData = ref([])//已添加数据-生成报价单-品牌table数据
    const disabledIndexes = ref([])//添加完按钮禁用
    const addedNum = ref(0)//已添加条数
    const percentOptions = ref([ //数据列表下拉的百分比
      { label: '+10%', value: 0.1 },
      { label: '+20%', value: 0.2 },
      { label: '+30%', value: 0.3 },
      { label: '-10%', value: -0.1 },
      { label: '-20%', value: -0.2 },
      { label: '-30%', value: -0.3 },
      { label: '-40%', value: -0.4 },
      { label: '-50%', value: -0.5 },
      { label: '-60%', value: -0.6 },
      { label: '-70%', value: -0.7 }
    ])
    const renshu1 = ref(0.1)
    const renshu2 = ref(-0.4)
    const renshu3 = ref(-0.5)
    const renshu4 = ref(-0.6)

    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name

    //已添加列表展示
    const addToDrawer = (row, type, index) => {
      if (!disabledIndexes.value.includes(row.id)) {
        disabledIndexes.value.push(row.id);
      }
      drawerVisible.value = true
      request({
        url: 'add_cart.yy',
        method: 'post',
        data: {
          id: row.id,
          username: username,
          type: type   //type 1 库存商品  2 数据列表
        }
      }).then(res => {
        const { code, msg } = res
        addedData.value = res.cartlist
        if (code == 200) {
          Message.success(msg)
        } else if (code == 300) {
          Message.warning(msg)
        } else if (code == 400) {
          Message.error(msg)
        }
      })
    }
    //已添加数据-单个删除
    const removeFromDrawer = ({ id }, index) => {
      request({
        url: 'delete_cart.yy',
        method: 'post',
        data: { id: id, username: username }
      }).then(res => {
        if (res.code == 200) {
          deleteRow(index)
          disabledIndexes.value = disabledIndexes.value.filter(id => id !== id);
          getList(xhName.value)
        }
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }
    const deleteRow = (index) => {
      addedData.value.splice(index, 1)
    }
    //已添加数据-全部删除
    const handleClear = () => {
      const ids = addedData.value.map(item => item.id)
      request({
        url: 'delete_cart.yy',
        method: 'post',
        data: { id: ids, username: username }
      }).then(res => {
        if (res.code == 200) {
          Message.success(res.msg)
          addedData.value = []
          addedNum.value = 0
        }
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
      drawerVisible.value = false
    }

    //远程搜索型号方法
    const remoteMethod = async (query) => {
      if (!query) {
        options.value = []
        return
      }
      loading.value = true
      try {
        const { data } = await request({
          url: 'bearing_quotation_xh.yy',
          method: 'post',
          data: { xh: query }
        })

        options.value = data.map(item => ({
          label: item,
          value: item
        }))
      } catch (error) {
        console.error('搜索失败', error)
      } finally {
        loading.value = false
      }
    }

    // const pageSizeChange = () => {
    // }
    // const pageCurrentChange = () => {
    // }
    //搜索型号后获取库存和数据列表
    const getList = (xh, source, address) => {
      request({
        url: 'bearing_quotation.yy',
        method: 'post',
        data: {
          username: username,
          xh: xh,
          source: source,
          address: address
        }
      }).then(res => {
        if (res.code == 200) {
          const { lista, listb, source, address, num } = res
          inventory.value = lista
          data.value = listb
          sourceData.value = source
          addressData.value = address
          addedNum.value = num
        }
      })
    }

    //模糊下拉型号选中请求接口
    const handleChange = (xh) => {
      xhName.value = xh
      getList(xh)
    }

    const selectRef = ref(null)
    const handleGlobalClick = (e) => {
      const isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);
      if (isMobile && selectRef.value?.$el.contains(e.target)) {
        nextTick(() => {
          const input = selectRef.value.$el.querySelector('input');
          if (input) {
            input.removeAttribute('readonly');
            input.focus();

            // 强制展开下拉菜单（适配 Element Plus）
            selectRef.value.handleFocus();
          }
        });
      }
    };

    onMounted(() => {
      document.addEventListener('click', handleGlobalClick, true);
    });

    onBeforeUnmount(() => {
      document.removeEventListener('click', handleGlobalClick, true);
    });
    //品牌搜索
    const handleSource = (val) => {
      ArticleSource.value = val
      selectedSourceTag.value = val
    }
    //价格来源搜索
    const handleAddress = (val) => {
      address.value = val
      selectedAddressTag.value = val
    }
    //品牌不限搜索
    const getAllSource = () => {
      selectedSourceTag.value = 1
      ArticleSource.value = ''
    }
    //价格来源不限搜索
    const getAllAddress = () => {
      selectedAddressTag.value = 2
      address.value = ''
    }
    //动态计算数据列表的价格
    const calcPrice = (price, percent) => {
      return (price * (1 + percent)).toFixed(2)
    }
    const updatePrices = () => {
      data.value = data.value.map(row => ({
        ...row,
        updatedPrice: calcPrice(row.renshu1, renshu1.value)
      }))
    }

    //实时监听搜索的条件
    watch(()=>[address.value,ArticleSource.value],([address,source])=>{
      getList(xhName.value,source,address)
    },{deep:true})

    //新增型号方法
    const handleAdd = () => {
      dialog.value = true
      addPageRef.value.handleReset()
    }
    //型号表单提交
    const handleAddSubmit = ({ code, msg }) => {
      if (code == 200) {
        Message({ type: 'success', message: msg })
        dialog.value = false
      }
    }
    //型号弹窗关闭
    const handleAddClose = () => {
      dialog.value = false
    }
    //已添加数据-生成报价单展示弹窗
    const handleQuotation = (data) => {
      drawerVisible.value = false
      quotationDialog.value = true
      quotationData.value = data
    }
    //已添加数据-生成报价单弹窗关闭
    const quotationClose = () => {
      quotationDialog.value = false
    }

    //列表每行添加数据
    const handleAddXname = () => {
      drawerVisible.value = true
      request({
        url: 'add_cart.yy',
        method: 'post',
        data: {
          username: username
        }
      }).then(res => {
        addedData.value = res.cartlist
      })
    }

    return {
      selectRef,
      getIsMobile,
      addedNum,
      disabledIndexes,
      username,
      quotationData,
      quotationDialog,
      dialog,
      selectedSourceTag,
      selectedAddressTag,
      xhName,
      address,
      ArticleSource,
      sourceData,
      addressData,
      renshu1,
      renshu2,
      renshu3,
      renshu4,
      percentOptions,
      // selectPage,
      addedData,
      inventory,
      data,
      drawerVisible,
      keyword,
      loading,
      options,
      addPageRef,
      handleGlobalClick,
      quotationClose,
      handleAddXname,
      handleClear,
      handleQuotation,
      handleAddClose,
      handleAddSubmit,
      handleAdd,
      calcPrice,
      getAllSource,
      getAllAddress,
      handleAddress,
      handleSource,
      updatePrices,
      handleChange,
      addToDrawer,
      removeFromDrawer,
      remoteMethod
      // pageSizeChange,
      // pageCurrentChange
    }
  }
})
</script>
<style scoped lang="scss">
.model-card {
  margin: 10px;

  .model-tag {
    margin-bottom: 10px;
  }
}

.model-select {
  width: 60%;
  margin: 20px 10px 10px 10px;
}
.model-table {
  margin: 20px auto;
  box-sizing: border-box;
  overflow: hidden;
  width: 98.8%;
}

.drawer-table {
  width: 95%;
  margin: auto;
}

.custom-btn {
  margin-left: 10px;
}

.dialog-footer {
  text-align: center;
  margin-top: 25px;
}

.add-btn {
  position: fixed;
  right: 0;
  top: 450px;
  z-index: 99
}
/* 针对 Element Plus */
.el-select input {
  pointer-events: auto !important;
  -webkit-user-modify: read-write !important;
}


</style>
